import I18n from "i18n-js";
import React from "react";

import {
  ActivityIndicator,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  SafeAreaView
} from "react-native";
import { connect } from "react-redux";
import Markdown from "react-native-markdown-renderer";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";
import { getBaseUrl } from "../helpers/storage";

class ConsentScreen extends React.Component {
  state = {
    isLoading: true,
    consent: null
  };

  async fetchConsent() {
    const token = this.props.token;

    const response = await fetch(getBaseUrl() + "consultations/consent", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const json = await response.json();

    this.setState({
      isLoading: false,
      consent: json["data"]
    });
  }

  componentDidMount() {
    this.fetchConsent();
  }

  handleCancelPress() {
    this.props.navigation.goBack();
  }

  render() {
    const { themeColors } = this.props;

    let content = null;

    if (this.state.isLoading) {
      content = <ActivityIndicator size="large" color={themeColors.primary} />;
    } else {
      content = <Markdown style={markdownStyles}>{this.state.consent}</Markdown>;
    }

    return (
      <View
        style={[styles.container, { backgroundColor: themeColors.primary }]}
      >
        <SafeAreaView>
          <TouchableOpacity
            onPress={() => this.handleCancelPress()}
            style={styles.cancelButton}
          >
            <Image
              source={require("../assets/icons/round_arrow_back_ios_white_18dp.png")}
            />
            <Text style={styles.cancelText}>{I18n.t("prixa.cancel")}</Text>
          </TouchableOpacity>
        </SafeAreaView>
        <View
          style={{
            flexGrow: 1,
            backgroundColor: themeColors.lightestPrimary,
            borderTopEndRadius: 40,
            borderTopStartRadius: 40
          }}
        >
          <ScrollView style={{ padding: 25, flex: 1 }}>
            <Text
              style={{
                marginBottom: 20,
                alignSelf: "center",
                color: themeColors.darkestPrimary,
                fontSize: 22,
                ...fonts.bold
              }}
            >
              Penjelasan dan Persetujuan
            </Text>

            {content}
          </ScrollView>
        </View>
        <View
          style={{
            backgroundColor: "white",
            padding: 25,
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          <TouchableOpacity
            style={{
              backgroundColor: "#E64F4F",
              borderRadius: 20,
              paddingVertical: 12,
              paddingHorizontal: 48
            }}
            onPress={() => this.props.navigation.goBack()}
          >
            <Text
              style={{
                color: "white",
                fontSize: 16,
                ...fonts.bold
              }}
            >
              Tolak
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              backgroundColor: "#5DBE66",
              borderRadius: 20,
              paddingVertical: 12,
              paddingHorizontal: 48
            }}
            onPress={() => {
              this.props.navigation.replace("Waiting", {
                patientId: this.props.navigation.state.params.patientId,
                // cardNumberDependency: this.props.navigation.state.params
                //   .cardNumberDependency,
                dependent: this.props.navigation.state.params.dependent,
                consultation: this.props.navigation.state.params.consultation,
                complaintIds: this.props.navigation.state.params.complaintIds,
                duration: this.props.navigation.state.params.duration,
                durationUnit: this.props.navigation.state.params.durationUnit
              });
            }}
          >
            <Text
              style={{
                color: "white",
                fontSize: 16,
                ...fonts.bold
              }}
            >
              Setuju
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  cancelButton: {
    alignItems: "center",
    flexDirection: "row",
    padding: 15
  },
  cancelText: {
    color: staticColors.white,
    fontSize: 16,
    marginStart: 15,

    ...fonts.bold
  },
  container: {
    flex: 1
  }
});

const markdownStyles = StyleSheet.create({
  text: {
    textAlign: 'justify',
  },
  heading: {
    textAlign: 'justify',
  },
  bullet_list: {
    textAlign: 'justify',
  },
  ordered_list: {
    textAlign: 'justify',
  },
  list_item: {
    textAlign: 'justify',
  },
});

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(ConsentScreen);
